<div *ngIf="active" class="tab-content" [@fadeIn]>
  <ng-content></ng-content>
</div>
